// data/items/hides.js
// Hide items for armor crafting - 6 tiers

export const HIDES = [
    // Tier 1 - Treated
    {
        id: 'treated_hide',
        name: 'Treated Hide',
        color: '#8B4513',
        tier: 1,
        value: 15
    },
    // Tier 2 - Green Wyrm
    {
        id: 'green_wyrm_hide',
        name: 'Green Wyrm Hide',
        color: '#2E8B57',
        tier: 2,
        value: 35
    },
    // Tier 3 - Blue Wyrm
    {
        id: 'blue_wyrm_hide',
        name: 'Blue Wyrm Hide',
        color: '#4169E1',
        tier: 3,
        value: 60
    },
    // Tier 4 - Red Wyrm
    {
        id: 'red_wyrm_hide',
        name: 'Red Wyrm Hide',
        color: '#DC143C',
        tier: 4,
        value: 95
    },
    // Tier 5 - Black Drake
    {
        id: 'black_drake_hide',
        name: 'Black Drake Hide',
        color: '#1C1C1C',
        tier: 5,
        value: 140
    },
    // Tier 6 - Void Drake
    {
        id: 'void_drake_hide',
        name: 'Void Drake Hide',
        color: '#4B0082',
        tier: 6,
        value: 200
    }
];

export default HIDES;
